import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
import { AtividadeUsuarioService } from "./services/atividade-usuario.service";
import { AuthService } from "./services/auth.service";
import { Component, HostListener, OnInit } from "@angular/core";
import { AppService } from "./services/app.service";
import { ImpressaoService } from "./services/impressao.service";
import { KanbanService } from "./services/kanban.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "ordermanager-desktop";
  rotaCarregada = false;

  constructor(
    private router: Router,
    public authService: AuthService,
    private kanbanService: KanbanService,
    private atividadeUsuario: AtividadeUsuarioService,
    public appService: AppService,
    private route: ActivatedRoute,
    private impressaoService: ImpressaoService,
  ) {
    const windowInnerWidth = window.innerWidth;
    const isMenuCollapsed = windowInnerWidth < 900;
    this.setAttributeMenuCollapsedOnTagBody(isMenuCollapsed);

    this.router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        const codigoLoja = val.state.root.firstChild.params['codigo'] ?? null;

        if (!!codigoLoja) {
          localStorage.setItem("CodigoLoja", codigoLoja);
          this.router.navigateByUrl("/");
        }
      }
      this.rotaCarregada = true;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const isMenuCollapsed = event.target.innerWidth < 900;
    this.setAttributeMenuCollapsedOnTagBody(isMenuCollapsed);
  }

  ngOnInit() {

    this.impressaoService.listarImpressoras();



  }

  setAttributeMenuCollapsedOnTagBody(isMenuCollapsed: boolean) {
    this.appService.sideBarEstaVisivel = !isMenuCollapsed;
    if (isMenuCollapsed === this.appService.modoMobileEstaAtivado) {
      return;
    };
    this.appService.modoMobileEstaAtivado = isMenuCollapsed;
    this.appService.cardDragDelayInMilisenconds = isMenuCollapsed ? 500 : 0;
    document.body.setAttribute("isMenuCollpsed", isMenuCollapsed ? "true" : "false");
  }

  toggle_function() {
    this.atividadeUsuario.registrar();
    //variaveis para troca de status
    let open = document.querySelector<HTMLElement>("#on");
    let closed = document.querySelector<HTMLElement>("#off");

    // Logica de substituição
    if (open.style.display === "none") {
      closed.style.display = "none";
      open.style.display = "block";
    } else {
      closed.style.display = "block";
      open.style.display = "none";
    }
  }

  get usuarioEstaLogado() {
    return this.authService.logado;
  }

  logOff() {
    this.atividadeUsuario.registrar();
    this.authService.logOff();
  }

  perfilRedirect() {
    this.atividadeUsuario.registrar();
    this.router.navigate(["/config"]);
  }

  updateAtividade() {
    this.atividadeUsuario.registrar();
  }
}
